<div class="card-custom shadow-sm">

  <div class="card-body">

    <h4 class="mb-4">
      <i class="fa-solid fa-user-plus"></i>
      Nuovo Paziente
    </h4>

    <form #form="ngForm" (ngSubmit)="save()">

      <!-- NOME -->

      <div class="mb-3">

        <label class="form-label">
          Nome
        </label>

        <input type="text" class="form-control" [(ngModel)]="nome" name="nome" required #nomeCtrl="ngModel">

      </div>

      <div class="text-danger mt-1" *ngIf="nomeCtrl.invalid && nomeCtrl.touched">

        Il nome è obbligatorio

      </div>

      <!-- COGNOME -->

      <div class="mb-3">

        <label class="form-label">
          Cognome
        </label>

        <input type="text" class="form-control" [(ngModel)]="cognome" name="cognome" required #cognomeCtrl="ngModel">

      </div>

      <div class="text-danger mt-1" *ngIf="cognomeCtrl.invalid && cognomeCtrl.touched">

        Il cognome è obbligatorio

      </div>

      <!-- GENERE -->

      <div class="mb-3">

        <label class="form-label">
          Genere
        </label>

        <select class="form-select" [(ngModel)]="genere" name="genere">

          <option value="">
            --
          </option>

          <option value="M">
            M
          </option>

          <option value="F">
            F
          </option>

        </select>

      </div>

      <!-- DATA NASCITA -->

      <div class="mb-3">

        <label class="form-label">
          Data di nascita
        </label>

        <input type="date" class="form-control" [(ngModel)]="dataNascita" name="dataNascita" required
          #dataNascitaCtrl="ngModel">

        <div *ngIf="dataNascita" class="mt-2 text-muted">

          <i class="fa-solid fa-cake-candles me-1"></i>

          Età calcolata:
          <strong>

            {{ utilitiesHelper.calculateAge(dataNascita) }} anni

          </strong>

        </div>

      </div>

      <div class="text-danger mt-1" *ngIf="dataNascitaCtrl.invalid && dataNascitaCtrl.touched">

        La data di nascita è obbligatoria

      </div>

      <!-- BUTTON -->

      <button class="btn btn-teal-custom me-4" [disabled]="form.invalid">
        <i class="fa-solid fa-user-plus"></i>
        Salva Paziente
      </button>

      <button class="btn btn-soft-senior" (click)="goHome()">
        <i class="fa-solid fa-arrow-left me-1"></i>
        Torna alla Home
      </button>

    </form>

    <!-- SUCCESS -->

    <div *ngIf="success" class="alert alert-success mt-3">

      {{ success }}

    </div>

    <!-- ERROR -->

    <div *ngIf="error" class="alert alert-danger dismissible mt-3">

      {{ error }}

    </div>

  </div>

</div>

<!-- DUPLICATE MODAL -->

<div *ngIf="showDuplicateModal" class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,0.5)">

  <div class="modal-dialog">

    <div class="modal-content">

      <div class="modal-header">

        <h5 class="modal-title">
          Attenzione: Paziente già esistente
        </h5>

      </div>

      <div class="modal-body">

        <p>
          È stato trovato un paziente
          con le stesse caratteristiche.
        </p>

        <ul class="list-group">

          <li class="list-group-item">
            <strong>Codice:</strong>
            {{ duplicatePatient.codice }}
          </li>

          <li class="list-group-item">
            <strong>Nome:</strong>
            {{ duplicatePatient.nome }}
          </li>

          <li class="list-group-item">
            <strong>Cognome:</strong>
            {{ duplicatePatient.cognome }}
          </li>

          <li class="list-group-item">
            <strong>Genere:</strong>
            {{ duplicatePatient.genere }}
          </li>

          <li class="list-group-item">
            <strong>Data nascita:</strong>
            {{ duplicatePatient.dataNascita | date:'dd/MM/yyyy' }}
          </li>

        </ul>

      </div>

      <div class="modal-footer">

        <button class="btn btn-secondary" (click)="showDuplicateModal = false">
          <i class="fa-solid fa-xmark"></i>
          Annulla

        </button>

        <button class="btn btn-primary" (click)="selectExistingPatient()">

          <i class="fa-solid fa-user-check"></i>

          Seleziona paziente esistente
        </button>

        <button class="btn btn-teal-custom" (click)="createAnyway()">
          <i class="fa-solid fa-circle-check"></i>
          Crea nuovo paziente

        </button>

      </div>

    </div>

  </div>

</div>